import classNames from 'classnames';
import { FC } from 'react';
import { cardEmphasisFromStatus } from '../StatusTracker/StatusTracker';
import { StatusTrackerStatus } from '../StatusTracker/StatusTracker.types';
import styles from './ProgressIndicator.module.css';
import { ProgressIndicatorProps } from './ProgressIndicator.types';

const ProgressIndicator: FC<ProgressIndicatorProps> = ({ progress = 0, status = StatusTrackerStatus.Pending }) => (
  <div className={styles.progressBar}>
    <div className={styles.bar} />
    <div
      data-testid="progressBar"
      className={classNames(styles.filledBar, styles[cardEmphasisFromStatus(status)])}
      style={{ width: `${progress}%` }}
    />
    <div className={styles.events}>
      {/* start (0%) */}
      <div className={styles.progressEvent} style={{ left: `calc(0% - 2px)` }} key="zeroPercent">
        <div
          className={classNames(styles.progressCircle, {
            [styles[cardEmphasisFromStatus(status)]]: progress !== undefined && progress > 0,
          })}
        />
      </div>
      {/* end (100%) */}
      <div className={styles.progressEvent} style={{ left: `calc(100% - 2px)` }} key="hundredPercent">
        <div
          className={classNames(styles.progressCircle, {
            [styles[cardEmphasisFromStatus(status)]]: progress !== undefined && progress > 99,
          })}
        />
      </div>
      {/* current progress indicator (progress prop) */}
      <div
        className={styles.progressEvent}
        style={{ left: `calc(${progress}% - 2px)` }}
        data-testid="progress"
        key="currentProgress"
      >
        <div
          className={classNames(styles.progressCircle, styles.currentProgress, styles[cardEmphasisFromStatus(status)])}
        >
          <span />
        </div>
        <div className={styles.progressLabel} />
      </div>
    </div>
  </div>
);

export default ProgressIndicator;
